import axios from "axios";

const apiHost = 'https://eurofarma.nexfar.com.br/';

const Nexfar = {
    login(formValues) {
        let stringFormated = '';

        Object.keys(formValues).forEach(function (index) {
            if (stringFormated !== '') {
                stringFormated += '&';
            }
            stringFormated += index + '=' + formValues[index];
        });

        return axios.post(
            apiHost + 'api/login',
            stringFormated,
            {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
        ).then((res) => {
            return res.data;
        }).catch((err) => {
            if (err.response.status === 404) {
                return null;
            }
            return err.response.data;
        });
    },
    doRegistrationActivation(token) {
        return axios.post(
            apiHost + 'api/activation/activate/' + token,
            {headers: {'Content-Type': 'application/json'}}
        ).then((res) => {
            return res.data;
        }).catch((err) => {
            if (err.response.status === 404) {
                return null;
            }
            return err.response.data;
        });
    },
    registration(formValues) {
        return axios.post(
            apiHost + 'api/activation/pre-activate',
            formValues,
            {headers: {'Content-Type': 'application/json'}}
        )
    },
    validateCPNJ(cnpj) {
        return axios.get(
            apiHost + 'api/activation/' + cnpj + '/status',
            {headers: {'Content-Type': 'application/json'}}
        ).then((res) => {
            return res.data;
        }).catch((err) => {
            if (err.response.status === 404) {
                return null;
            }
            return err.response.data;
        });
    },
    getLoginRedirectURL(token){
        let host = apiHost;
        return host += '#/?authToken=' + token;
    }
}
export default Nexfar;